import React, { useState } from "react";

// @mui/material components
import {makeStyles} from "@mui/styles";

// core components
import Boxes from "./boxes";
import CreateDialog from './createDialog';
import DeleteDialog from './deleteDialog';
import EditDialog from './editDialog';
import NoResult from '../../configuration/components/noResult';
import { default as Popover } from '../../configuration/components/popover';

// styles
const useStyles = makeStyles(theme => ({
    removeUlPadding: {
        padding: 0,
        margin: 0,
        listStyleType: "none"
    },
}));

export default function EnhancedTableBody (props) {
    const { checkedSectors, retrieved, search, setCheckedSectors } = props;

    const classes = useStyles();

    const [createSubDialog, showCreateSubDialog] = useState(false);
    const [deleteDialog, showDeleteDialog] = useState(false);
    const [editDialog, showEditDialog] = useState(false);

    const [sectorSelected, setSectorSelected] = useState(null);
    const [sectorTablePosition, setSectorTablePosition] = useState(null);

    const [openPopover, setOpenPopover] = useState(false);

    return (
        <div className={classes.removeUlPadding}>
            {(retrieved && retrieved.length > 0) && (
                <Boxes
                    allSectors={retrieved}
                    openCreatedDialog={() => showCreateSubDialog(true)}
                    selectSector={setSectorSelected}
                    setSectorTablePosition={setSectorTablePosition}
                    openPopover={() => setOpenPopover(true)}
                    search={search}
                    checkedSectors={checkedSectors}
                    setCheckedSectors={setCheckedSectors}
                />
            )}
            {retrieved && retrieved.length === 0 && (
                <NoResult />
            )}
            {sectorSelected && (
                <div>
                    <CreateDialog
                        isOpen={createSubDialog}
                        closeDialog={() => showCreateSubDialog(false)}
                        sector={sectorSelected}
                        isSubSector={true}
                    />
                    <DeleteDialog
                        isOpen={deleteDialog}
                        closeDialog={() => showDeleteDialog(false)}
                        sector={sectorSelected}
                    />
                    <EditDialog
                        isOpen={editDialog}
                        closeDialog={() => showEditDialog(false)}
                        sector={sectorSelected}
                        isSubSector={sectorSelected.parent !== null}
                    />
                </div>
            )}
            <Popover
                isPopoverOpen={openPopover}
                closePopover={() => setOpenPopover(false)}
                position={sectorTablePosition}
                openDeleteDialog={() => showDeleteDialog(true)}
                openEditDialog={() => showEditDialog(true)}
                attributeName={'sector'}
            />
        </div>
    );
}
